var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBtnProceedToCheckout = function SvgIconBtnProceedToCheckout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.75 4.5h4.5a2.25 2.25 0 1 0-4.5 0m-1.5 0a3.75 3.75 0 0 1 7.5 0H13a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75H1a.75.75 0 0 1-.75-.75V5.25A.75.75 0 0 1 1 4.5zM1.75 6v9h10.5V6zm3 1.5a2.25 2.25 0 1 0 4.5 0h1.5a3.75 3.75 0 0 1-7.5 0z"
  })));
};
export default SvgIconBtnProceedToCheckout;